module.exports = __webpack_public_path__ + "static/media/onboarding-setup-success.98132b0f.png";